"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSvgIcon = exports.SvgColor = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var Icon_module_css_1 = __importDefault(require("./Icon.module.css"));
var SvgColor;
(function (SvgColor) {
    SvgColor["SUCCESS"] = "success";
    SvgColor["ERROR"] = "error";
})(SvgColor || (exports.SvgColor = SvgColor = {}));
/* Helps ensure refs are passed as props to each component */
function buildSvgIcon(content, displayName, defaultSvgProps) {
    if (defaultSvgProps === void 0) { defaultSvgProps = {}; }
    var component = react_1.default.forwardRef(function (props, ref) {
        var _a;
        var className = props.className, _b = props.contentProps, contentProps = _b === void 0 ? {} : _b, instanceSvgProps = __rest(props, ["className", "contentProps"]);
        // Set the color to the color from instanceSvgProps if provided, otherwise use the color from defaultSvgProps
        var color = instanceSvgProps.color || defaultSvgProps.color;
        var classes = (0, clsx_1.default)(className, Icon_module_css_1.default.root, (_a = {},
            _a[Icon_module_css_1.default.success] = color === SvgColor.SUCCESS,
            _a[Icon_module_css_1.default.error] = color === SvgColor.ERROR,
            _a));
        var rootProps = __assign(__assign(__assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: defaultSvgProps.viewBox || '0 0 24 24', ref: ref }, defaultSvgProps), instanceSvgProps), { className: classes, color: Object.values(SvgColor).includes(color)
                ? undefined
                : color });
        return (react_1.default.createElement("svg", __assign({}, rootProps), typeof content === 'function' ? content(contentProps) : content));
    });
    component.displayName = displayName;
    return react_1.default.memo(component);
}
exports.buildSvgIcon = buildSvgIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGQtc3ZnLWljb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9pY29ucy9idWlsZC1zdmctaWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGdEQUEwQjtBQUUxQiw4Q0FBd0I7QUFDeEIsc0VBQW9DO0FBRXBDLElBQVksUUFHWDtBQUhELFdBQVksUUFBUTtJQUNsQiwrQkFBbUIsQ0FBQTtJQUNuQiwyQkFBZSxDQUFBO0FBQ2pCLENBQUMsRUFIVyxRQUFRLHdCQUFSLFFBQVEsUUFHbkI7QUFZRCw2REFBNkQ7QUFDN0QsU0FBZ0IsWUFBWSxDQUMxQixPQUF5RCxFQUN6RCxXQUFtQixFQUNuQixlQUFtRDtJQUFuRCxnQ0FBQSxFQUFBLG9CQUFtRDtJQUVuRCxJQUFNLFNBQVMsR0FBRyxlQUFLLENBQUMsVUFBVSxDQUNoQyxVQUFDLEtBQXVCLEVBQUUsR0FBZ0M7O1FBQ2hELElBQUEsU0FBUyxHQUE2QyxLQUFLLFVBQWxELEVBQUUsS0FBMkMsS0FBSyxhQUEvQixFQUFqQixZQUFZLG1CQUFHLEVBQUUsS0FBQSxFQUFLLGdCQUFnQixVQUFLLEtBQUssRUFBN0QsNkJBQXFELENBQUYsQ0FBVztRQUVwRSw2R0FBNkc7UUFDN0csSUFBTSxLQUFLLEdBQUcsZ0JBQWdCLENBQUMsS0FBSyxJQUFJLGVBQWUsQ0FBQyxLQUFLLENBQUM7UUFFOUQsSUFBTSxPQUFPLEdBQUcsSUFBQSxjQUFJLEVBQUMsU0FBUyxFQUFFLHlCQUFHLENBQUMsSUFBSTtZQUN0QyxHQUFDLHlCQUFHLENBQUMsT0FBTyxJQUFHLEtBQUssS0FBSyxRQUFRLENBQUMsT0FBTztZQUN6QyxHQUFDLHlCQUFHLENBQUMsS0FBSyxJQUFHLEtBQUssS0FBSyxRQUFRLENBQUMsS0FBSztnQkFDckMsQ0FBQztRQUVILElBQU0sU0FBUyxnQ0FDYixLQUFLLEVBQUUsNEJBQTRCLEVBQ25DLE9BQU8sRUFBRSxlQUFlLENBQUMsT0FBTyxJQUFJLFdBQVcsRUFDL0MsR0FBRyxLQUFBLElBQ0EsZUFBZSxHQUNmLGdCQUFnQixLQUNuQixTQUFTLEVBQUUsT0FBTyxFQUNsQixLQUFLLEVBQUUsTUFBTSxDQUFDLE1BQU0sQ0FBUyxRQUFRLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBZSxDQUFDO2dCQUM5RCxDQUFDLENBQUMsU0FBUztnQkFDWCxDQUFDLENBQUMsS0FBSyxHQUNWLENBQUM7UUFDRixPQUFPLENBQ0wsa0RBQVMsU0FBUyxHQUNmLE9BQU8sT0FBTyxLQUFLLFVBQVUsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQzVELENBQ1AsQ0FBQztJQUNKLENBQUMsQ0FDRixDQUFDO0lBRUYsU0FBUyxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7SUFFcEMsT0FBTyxlQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDO0FBQy9CLENBQUM7QUF2Q0Qsb0NBdUNDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/build-svg-icon.js
// module id = 20
// module chunks = 25